import React from "react";

const STATUS_STYLES = {
  Started: "bg-amber-50 text-amber-700",
  "In-Progress": "bg-blue-50 text-blue-700",
  Partial: "bg-indigo-50 text-indigo-700",
  Completed: "bg-emerald-50 text-emerald-700",
  AMC: "bg-purple-50 text-purple-700",
};

export default function VendorStatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-600";
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${cls}`}
      data-testid={`vendor-status-${status}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: "currentColor" }} />
      {status}
    </span>
  );
}
